import ConsultantDTO from '@src/adapters/dto/consultant/ConsultantDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {}

interface Result {
  items: ConsultantDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/consultant/visible/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindConsultantsVisibleLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindConsultantsVisibleLazy;
